module.exports = __webpack_public_path__ + "img/Group12467@2x.ded026fa.png";